"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_need__help(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "24-7-support-hi"), /*#__PURE__*/React.createElement("g", {
    id: "9b654dab-2fce-4680-a704-d4f79d5258f9",
    "data-name": "24-7-support-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8eb2dc9a-f190-4d71-9826-632159e6b165",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "67dfe279-4434-4e0b-8367-87b13175df34",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6801402b-cf56-492b-9ed2-7a68a744b1ef",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "4bb9934e-40da-4f43-a96f-14faefad17a1",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "727311e9-190b-4304-a0b9-c2c8f1a524b0",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e5da38c2-c3d7-44ad-872b-f88874694f08",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "535a0d0c-2d40-4f3a-8d92-d179a909af70",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dd6b358b-3d22-4306-8cbe-2e633ccadb00",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6bc5ffc8-9570-44a1-aecb-50dd288808a1",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f4d42143-9be6-4aad-8e1f-9b3b6f7e601e",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "58da5b3d-2acd-4117-af1d-978f7137e6bf",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ad6edc05-0a1e-483e-995c-9d0642aa9d1e",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0c7c6b82-e6e4-4212-abde-c9f3f7c596ce",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "db74b65a-fbfa-4bea-a2f3-ba908e2b45f2",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "678d8e23-eed6-4d4e-9cb2-af2d75bd574c",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a0ffd470-fb85-4b1e-950d-8b5d3bf5fcb1",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a3d0751d-ea2f-49ce-9d66-759ac29e6eba",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "50ef4eae-8380-4d7f-b1bb-250ac9231b3c",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c8707b51-a33c-4836-bfde-bb43d0959c4f",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3a843aa5-d7b4-449b-bec8-9f47a5f33cc8",
    "data-name": "Reports_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a8310ab4-be66-4969-babd-2fd84711e439",
    "data-name": "Roaming_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f2a3da40-1ed9-4c53-9733-22eec99c0ab2",
    "data-name": "Security_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "41d300b5-e68d-4ad1-8c7a-1c59c011e9e1",
    "data-name": "Sim_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0366a5c5-d873-41e3-95f9-38178eb346d5",
    "data-name": "Tablet_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5e3c0d39-18a1-4307-a786-92f4758ca88f",
    "data-name": "Text_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5991ff0a-da8f-4a9d-a239-87dfe17f204b",
    "data-name": "TV_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "92998f39-d2dc-4a0d-b8f6-3fbb3bb7bd60",
    "data-name": "Warning_ic_hi"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.33,164.85c12.11,12.3,29.52,12,47.33,10.5,0,0-16.56-6.95-21.51-28.51h0a77.16,77.16,0,1,0-25.82,18Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.33,162.85A77.23,77.23,0,0,1,18.79,92.6c0,.33,0,.66,0,1a77.25,77.25,0,0,0,107.57,71.25c12.11,12.3,29.52,12,47.33,10.5a24.52,24.52,0,0,1-3.18-1.74C153.79,174.85,137.73,174.41,126.33,162.85Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.64,92.6a77.47,77.47,0,0,1-21.49,52.24c.12.53.26,1.05.39,1.57A77.39,77.39,0,0,0,173.66,93.6C173.66,93.26,173.64,92.93,173.64,92.6Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,111.38V107a15.22,15.22,0,0,1,.41-3.48,8.25,8.25,0,0,1,1.46-3.15A12.1,12.1,0,0,1,47.28,98L55,92.11A11.6,11.6,0,0,0,58,89a6.73,6.73,0,0,0,.8-3.42A4.73,4.73,0,0,0,57.44,82a5.43,5.43,0,0,0-3.87-1.3,7.52,7.52,0,0,0-2.84.52,12.49,12.49,0,0,0-2.32,1.21,11.7,11.7,0,0,0-1.71,1.38l-1,1-3.37-5.3a14.65,14.65,0,0,1,2.79-2.4A17.39,17.39,0,0,1,49.41,75a16.08,16.08,0,0,1,5.22-.86,12.48,12.48,0,0,1,6.65,1.71,9.3,9.3,0,0,1,3.87,4.22,12.61,12.61,0,0,1,1.08,5,12.39,12.39,0,0,1-1.35,6,14.66,14.66,0,0,1-4.28,4.61l-5.52,4.09a37.84,37.84,0,0,0-3.73,3,3,3,0,0,0-1,2.13H66.67v6.41Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,111.38V104.2H70.53V98.73L87,74.54h5.69v23.3h3.59v6.35H92.73v7.18ZM78,97.85h7.79V86Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.72,113.15,97.42,110l23.3-40.92L125.92,72Z",
    transform: "translate(0 0)",
    fill: "#e60000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.49,111.38a59.72,59.72,0,0,1,4.45-15.3,85.44,85.44,0,0,1,8.7-15.24H128.18V74.54h24.35v6a89.39,89.39,0,0,0-8.95,15.27,62.34,62.34,0,0,0-4.69,15.54Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }))))))))))))))))))))))))))))));
}

var _default = ic_need__help;
exports.default = _default;